import React from "react";
import { Box, Typography, Grid2 as Grid } from "@mui/material";
import { useEntityHandlerContext } from "../../../controllers/entityController";
import { GetIntellexusDate } from "../../forms/common/intellexusDate/IntellexusDateField";
import { IntellexusDateStructure } from "../../../types/intellexusDate";

interface ViewRangeFieldProps {
  name: string;
  label: string;
}

const ViewRangeField: React.FC<ViewRangeFieldProps> = ({
  name,
  label,
}) => {
  const { methods } = useEntityHandlerContext();
  const data = methods.getValues();
  const rawValue = data?.[name as keyof typeof data];

  let displayValue = "N/A";
  if (rawValue !== undefined && rawValue !== null && rawValue !== "") {
    displayValue = GetIntellexusDate(rawValue as IntellexusDateStructure);
  }

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mb: 0.5 }}
        >
          {label}
        </Typography>
        <Typography variant="body1">{displayValue}</Typography>
      </Box>
    </Grid>
  );
};

export default ViewRangeField;
